import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Lottie from '@alltrails/lottie/Lottie';
import loadOut from './load-out.json';
import styles from './TextSent.module.scss';

export default function TextSent() {
  return (
    <>
      <div className={styles.title}>
        <Typography component="div" variant="heading400">
          <FormattedMessage defaultMessage="Text sent" />
        </Typography>
        <Typography color="secondary" component="div" variant="text200">
          <FormattedMessage defaultMessage="Check your phone for a notification" />
        </Typography>
      </div>
      <Lottie animationData={JSON.stringify(loadOut)} autoplay className={styles.lottie} />
    </>
  );
}
